import React, { useState } from 'react'
import QuantityControl from './QuantityControl'
import AddOnPickerModal from './AddOnPickerModal'
import { formatPrice } from '../utils/formatters'

// `quantity` is the total across every basket line for this item (a single
// plain line, or the sum of composite add-on lines). `onAdd(item, addOnIds)`
// adds a line; `onRemove(key)` decrements the plain line.
export default function MenuItem({ item, quantity, onAdd, onRemove }) {
  const hasAddOns = Array.isArray(item.add_ons) && item.add_ons.length > 0
  const [pickerOpen, setPickerOpen] = useState(false)

  return (
    <article className="bg-white rounded-lg p-4 flex items-center gap-4" aria-label={`${item.name}, ${formatPrice(item.price_pence)}`}>
      {item.image_url && (
        <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
          <img
            src={item.image_url}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="font-bold text-gray-900 truncate">{item.name}</h3>
          {item.popular && (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800">
              Popular
            </span>
          )}
        </div>
        {item.description && (
          <p className="text-sm text-gray-600 line-clamp-2">{item.description}</p>
        )}
        <p className="font-bold text-sky-900 mt-1">{formatPrice(item.price_pence)}</p>
        {hasAddOns && (
          <p className="text-xs text-gray-500 mt-0.5">Extras available</p>
        )}
      </div>

      {hasAddOns ? (
        <div className="flex items-center gap-2 flex-shrink-0" role="group" aria-label={`Quantity for ${item.name}`}>
          {quantity > 0 && (
            <span className="w-6 text-center font-medium" aria-label={`${quantity} in basket`}>
              {quantity}
            </span>
          )}
          <button
            type="button"
            onClick={() => setPickerOpen(true)}
            className="px-4 py-2 rounded-full bg-sky-900 text-white text-sm font-semibold hover:bg-sky-800 focus:outline-none focus:ring-2 focus:ring-sky-500"
            aria-label={`Add ${item.name}, choose extras`}
          >
            Add
          </button>
        </div>
      ) : (
        <QuantityControl
          quantity={quantity}
          onIncrease={() => onAdd(item, [])}
          onDecrease={() => onRemove(item.id)}
          itemName={item.name}
          showZeroState
          minusVariant="primary"
        />
      )}

      {pickerOpen && (
        <AddOnPickerModal
          item={item}
          onClose={() => setPickerOpen(false)}
          onConfirm={(addOnIds) => onAdd(item, addOnIds)}
        />
      )}
    </article>
  )
}
